<template>
  <v-list
    class="pa-0 ma-0 fonte unity-list"
    light
    two-line
    dense
    color="transparent"
    style="min-height: 20vh; max-height: 90vh; overflow: auto;"
  >
    <template v-for="(unidade, i) in showFiltereds">
      <v-list-item
        @click="open(unidade)"
        :key="unidade._id"
        class="fonte pl-3 pr-2 my-2 animate__animated animate__fadeInUp unity-list-item"
      >
        <v-list-item-content class="">
          <v-list-item-title class="fonte">
            {{ unidade.nome }}
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-icon color="#333" size="11">mdi-phone</v-icon>
            {{ unidade.phone }}
          </v-list-item-subtitle>
          <v-list-item-subtitle class="">
            CNPJ {{ unidade.cnpj || "nao informado" }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-avatar rounded size="36" color="#f2f2f2">
            <v-icon color="#f2f2f2">mdi-account-circle-outline</v-icon>
          </v-avatar>
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="i < showFiltereds.length - 1" :key="i"></v-divider>
    </template>
    <v-list-item
      style="min-height: 200px;"
      v-intersect="onIntersect"
    ></v-list-item>
  </v-list>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    filtereds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      itemsToShow: 12
    };
  },
  computed: {
    ...mapGetters(["get_unidade"]),
    showFiltereds() {
      return this.filtereds.slice(0, this.itemsToShow);
    }
  },
  methods: {
    onIntersect() {
      this.itemsToShow += 12;
    },
    open(unidade) {
      this.$store.commit("set_unidade", unidade);
    }
  }
};
</script>

<style scoped>
.unity-list {
  background: transparent !important;
}

.unity-list-item {
  background: #f4f5f7;
  border: 1px solid #e2e6ea;
  border-radius: 6px;
  color: #263238;
  min-height: 72px;
}

.unity-list-item:hover {
  background: #eceff1;
}
</style>
